import App from "@/App.tsx";
import { createRoot } from "react-dom/client";
import { initI18n } from "./utils";
initI18n().then(() => {
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
});
